// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__4IUXw","customInput":"Toggle_customInput__GiZBC","disabled":"Toggle_disabled__xjpQS","off":"Toggle_off__MBNRU"};